// extracted by mini-css-extract-plugin
export default {"message_container":"ErrorBoundary_message_container__CQgoQ","text":"ErrorBoundary_text__4RNng"};